import {
  ApiSavedSearch,
  ApiSavedSearchUnsaved,
} from 'api/savedSearch/types/ApiSavedSearch';
import { del } from 'utils/http/del';
import { postJson } from 'utils/http/postJson';

export function apiCreateSavedSearch({
  text,
  filters,
  location,
  index,
  radius,
}: ApiSavedSearchUnsaved): Promise<ApiSavedSearch> {
  return postJson<{ savedSearch: ApiSavedSearch }>('/data/saved-searches', {
    text,
    filters,
    radius,
    location,
    index,
  }).then(({ savedSearch }) => savedSearch);
}

export function apiDeleteSavedSearch(searchId: string) {
  return del(`/data/saved-searches/${searchId}`);
}
